import { Box, Typography } from "@mui/material";
import React from "react";

interface Props {
  data?: any;
}

const OrderTakingRequest: React.FC<Props> = ({ data }) => {
  const boxStyle = {
    px: 2,
    bgcolor: "white",
    // minHeight: "90px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    pb: 2,
    pt: 1,
    fontSize: "12px",
  };

  return (
    <Box sx={boxStyle}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box sx={{ border: "1px solid #e4e4e4", borderRadius: 1, p: 1, minWidth: 100 }}>
          <Typography fontSize={11} fontWeight={500}>
            Order No : {data?.orderNo ?? "—"}
          </Typography>
        </Box>
        <Box sx={{ border: "1px solid #e4e4e4", borderRadius: 1, p: 1, minWidth: 100 }}>
          <Typography fontSize={11} fontWeight={500}>
            Order Amt : SAR {data?.orderAmt ?? "—"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default OrderTakingRequest;
